import React from 'react'
import PropTypes from 'prop-types'
import FieldRAG_Icon from "../rag-icon"

// extends React.Component is required because of reference in parent
export default class FieldRag_MultiselectPopoverOption extends React.Component<any,any> {

    static propTypes = {
        option          : PropTypes.object,

        isHighlighted   : PropTypes.bool,
        isSelected      : PropTypes.bool,

        onClick         : PropTypes.func,
    }

    onClick = () => {this.props.onClick(this.props.option)}

    render() {
        const classes = Classes('option', 'pill', {
            'highlighted': this.props.isHighlighted
        })

        return (
            <div className={classes} onClick={this.onClick}>
                {!this.props.option.isAllValuesOption &&
                    <React.Fragment>
                        <div className={Classes("ui5-cb fl-no-shrink s-16 m-r-10", this.props.className, {selected: this.props.isSelected})}/>
                        <FieldRAG_Icon className="fl-ac fl-no-shrink m-r-8" option={this.props.option}/>
                        <div className="ui5-txt-default">{this.props.option.label}</div>
                    </React.Fragment>}

                {!!this.props.option.isAllValuesOption &&
                    <div className="ui5-txt-default">{this.props.option.label}</div>}
            </div>
        )
    }
}